import { getFromWebAPi } from '@/services/messaging/fetchQuery';

export function getBaseProductDetails(baseProductId, includeCustomerDetailsWhenAvailable) {
  return getFromWebAPi("Products/GetRegular?baseProductId=" + baseProductId + "&includeCustomerDetailsWhenAvailable=" + (includeCustomerDetailsWhenAvailable?"true":"false"));
}
